import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const alfaeldConfig: TSPConfig = {
  key: 'alfaeld',
  name: 'AlfaELD',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>Connect to AlfaELD by entering your API key.</p>
      <p>
        You can find your API key in your AlfaELD dashboard under Settings → API
        Access.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default alfaeldConfig;
